import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASS = "survey-pair-card--active"

// Connects to data-controller="survey-swipe"
// Translates horizontal touch gestures on the variants container
// into active-card changes: swipe left → next card, swipe right → previous.
// Vertical drags are ignored so the page can still scroll naturally.
export default class extends Controller {
  static targets = ["card", "container"]
  static values = {
    threshold: { type: Number, default: 40 }
  }

  connect() {
    this._startX = null
    this._startY = null
    this._scope = this.hasContainerTarget ? this.containerTarget : this.element
    this._onStart = (event) => this.onStart(event)
    this._onEnd = (event) => this.onEnd(event)
    this._scope.addEventListener("touchstart", this._onStart, { passive: true })
    this._scope.addEventListener("touchend", this._onEnd, { passive: true })

    if (this.cardTargets.length > 0 && this.activeIndex() === -1) {
      this.setActive(0)
    }
  }

  disconnect() {
    if (!this._scope) return
    this._scope.removeEventListener("touchstart", this._onStart)
    this._scope.removeEventListener("touchend", this._onEnd)
  }

  onStart(event) {
    const touch = event.changedTouches && event.changedTouches[0]
    if (!touch) return
    this._startX = touch.clientX
    this._startY = touch.clientY
  }

  onEnd(event) {
    if (this._startX === null) return
    const touch = event.changedTouches && event.changedTouches[0]
    const startX = this._startX
    const startY = this._startY
    this._startX = null
    this._startY = null
    if (!touch) return

    const dx = touch.clientX - startX
    const dy = touch.clientY - startY

    if (Math.abs(dx) < this.thresholdValue) return
    if (Math.abs(dy) >= Math.abs(dx)) return

    const direction = dx < 0 ? 1 : -1
    this.shift(direction)
  }

  shift(direction) {
    if (this.cardTargets.length < 2) return
    const current = Math.max(this.activeIndex(), 0)
    const next = current + direction
    if (next < 0 || next >= this.cardTargets.length) return
    this.setActive(next)
  }

  setActive(index) {
    this.cardTargets.forEach((card, i) => {
      const isActive = i === index
      card.classList.toggle(ACTIVE_CLASS, isActive)
      card.setAttribute("aria-pressed", isActive ? "true" : "false")
    })
    this.dispatch("activated", { detail: { index } })
  }

  activeIndex() {
    return this.cardTargets.findIndex((card) => card.classList.contains(ACTIVE_CLASS))
  }
}
